// extracted by mini-css-extract-plugin
export default {"map-container":"Map_map-container__Bn3-X","link":"Map_link__zW46C"};